/**
 * @file: earliestTrialEnd.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

/** The earliest of some trials' ends; null when none is on a trial. */
export function earliestTrialEnd(
  ends: readonly (string | null)[],
): string | null {
  return (
    ends
      .filter((x): x is string => x != null)
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())[0] ?? null
  );
}
